/**
 * @file: useQuotationTemplateConfig.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

import { useCurrentUserDangerously } from '@euler/app/flows/auth/context';
import { useCachedQuery } from '@euler/functions/useCachedQuery';
import { QuotationTemplateConfig } from '@euler/model/quotation';
import { useServiceFactory } from '@euler/services/factory';
import { onErrorReturn } from '@euler/utils';

export const kCustomQuotationTemplateCategoryId = '__CUSTOM__';
export const kVersion = '1.0';

export const useQuotationTemplateConfig = () => {
  const { inventoryService } = useServiceFactory();
  const user = useCurrentUserDangerously();
  const path = `store/${user.store.id}/quotation-template.json`;
  const cachedQuery = useCachedQuery<QuotationTemplateConfig>(
    path,
    0,
    async cached => {
      const res = await inventoryService.getQuotationTemplateConfig().catch(
        onErrorReturn<QuotationTemplateConfig>({
          version: '1.0',
          categories: [],
        }),
      );
      const customCategory = cached?.categories.find(
        x => x.id === kCustomQuotationTemplateCategoryId,
      );
      if (customCategory != null) {
        res.categories.push(customCategory);
      }
      return res;
    },
    true,
    { validate: object => object.version === kVersion },
  );

  return {
    ...cachedQuery,
  };
};
